import type { GetPresignedUrlForGetPayload } from "@/core/types";

export const presignedUrlKeys = {
  base: ["presignedUrl"] as const,
  get: (payload: Omit<GetPresignedUrlForGetPayload, "method" | "content_type">) =>
    [...presignedUrlKeys.base, JSON.stringify(payload)] as const,
};
